import { Basket as BasketNamespace } from './api/basket';
import { Catalog as CatalogNamespace } from './api/catalog';
import { Checkout as CheckoutNamespace } from './api/checkout';
import { Coupon as CouponNamespace } from './api/coupon';
import { Customer as CustomerNamespace } from './api/customer';
import { General as GeneralNamespace } from './api/general';
import { Indexer as IndexerNamespace } from './api/indexer';
import { Newsletter as NewsletterNamespace } from './api/newsletter';
import { Translate as TranslateNamespace } from './api/translate';
import { Wishlist as WishlistNamespace } from './api/wishlist';
export var Api;
(function (Api) {
    Api.Basket = BasketNamespace;
    Api.Catalog = CatalogNamespace;
    Api.Customer = CustomerNamespace;
    Api.Checkout = CheckoutNamespace;
    Api.Coupon = CouponNamespace;
    Api.General = GeneralNamespace;
    Api.Indexer = IndexerNamespace;
    Api.Newsletter = NewsletterNamespace;
    Api.Translate = TranslateNamespace;
    Api.Wishlist = WishlistNamespace;
})(Api || (Api = {}));
